import { render, staticRenderFns } from "./payShare copy.vue?vue&type=template&id=55557a4c&"
import script from "./payShare copy.vue?vue&type=script&lang=js&"
export * from "./payShare copy.vue?vue&type=script&lang=js&"
import style0 from "./payShare copy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports